import { render } from "./PatrocinarEstudiante.vue?vue&type=template&id=47d412ea&scoped=true"
import script from "./PatrocinarEstudiante.vue?vue&type=script&lang=js"
export * from "./PatrocinarEstudiante.vue?vue&type=script&lang=js"

import "./PatrocinarEstudiante.vue?vue&type=style&index=0&id=47d412ea&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47d412ea"]])

export default __exports__